import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './common/login/login.component';
import { SideNavComponent } from './components/side-nav/side-nav.component';
import { AuthGuard } from './auth.guard';

const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  // Parent route for SideNavComponent with nested child routes
  {
    path: 'components',
    component: SideNavComponent,  // The main layout with side navigation
    canActivate: [AuthGuard],
    children: [
      {
        path: 'Dashboard',
        loadChildren: () => import('./components/dashboard/dashboard.module').then(m => m.DashboardModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'Bookings',
        loadChildren: () => import('./components/bookings/bookings.module').then(m => m.BookingsModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'Reviews',
        loadChildren: () => import('./components/reviews/reviews.module').then(m => m.ReviewsModule),
        canActivate: [AuthGuard],
      }
    ]
  },

  // Wildcard route for invalid paths
  { path: '**', redirectTo: '/login' }
  // Add routes for protected components here
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }